/* SANDS product page V2 */
(function () {
  'use strict';

  function moneyNumber(cents, format) {
    var fmt = String(format || '{{amount}}').replace(/<[^>]*>/g, '');
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var type = match ? match[1] : 'amount';
    var n = (Number(cents) || 0) / 100;
    function fmtNum(decimals, thousands, dec) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? parts.join(dec) : parts[0];
    }
    switch (type) {
      case 'amount_no_decimals': return fmtNum(0, ',', '.');
      case 'amount_with_comma_separator': return fmtNum(2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return fmtNum(0, '.', ',');
      case 'amount_with_apostrophe_separator': return fmtNum(2, "'", '.');
      case 'amount_with_space_separator': return fmtNum(2, ' ', ',');
      default: return fmtNum(2, ',', '.');
    }
  }

  function money(cents, format) {
    var fmt = String(format || '{{amount}}').replace(/<[^>]*>/g, '');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, moneyNumber(cents, format));
  }

  function sized(src, width) {
    if (!src) return '';
    var s = src.indexOf('//') === 0 ? 'https:' + src : src;
    s = s.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function srcset(src) {
    return [700, 1100, 1500, 1900].map(function (w) { return sized(src, w) + ' ' + w + 'w'; }).join(', ');
  }

  function init(root) {
    if (root.__sp2) return;
    root.__sp2 = true;
    var dataEl = root.querySelector('[data-sp2-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var product = data.product || {};
    var variants = product.variants || [];
    var idInput = root.querySelector('[data-sp2-form] input[name="id"]');
    var addButtons = root.querySelectorAll('[data-sp2-add]');
    var initial = null;
    for (var k = 0; k < variants.length; k++) {
      if (idInput && String(variants[k].id) === String(idInput.value)) initial = variants[k];
    }

    // 24h delivery (UAE market, express product, variant in stock in Dubai)
    var ex = data.express || {};
    var exVariants = ex.variants || {};
    function expInfo(v) {
      if (!ex.on || !v || !v.available) return null;
      var info = exVariants[String(v.id)];
      return info && info.qty > 0 ? info : null;
    }
    var shipMode = 'express';
    var shipChecked = root.querySelector('[data-sp2-ship-input]:checked');
    if (shipChecked) shipMode = shipChecked.value;
    var expressProp = root.querySelector('[data-sp2-express-prop]');
    var errorEl = root.querySelector('[data-sp2-error]');
    var current = initial;

    // Match the price format the page actually shows (a currency app may rewrite it after load)
    var priceTpl = null;
    function priceText(cents) {
      if (priceTpl === null) {
        priceTpl = '';
        var shownEl = root.querySelector('[data-sp2-price]');
        var shown = shownEl ? shownEl.textContent.replace(/\s+/g, ' ').trim() : '';
        var num = data.shownCents != null ? moneyNumber(data.shownCents, data.moneyFormat) : (initial ? moneyNumber(initial.price, data.moneyFormat) : '');
        if (shown && num && shown.indexOf(num) > -1) priceTpl = shown.replace(num, '%n%');
      }
      return priceTpl ? priceTpl.replace('%n%', moneyNumber(cents, data.moneyFormat)) : money(cents, data.moneyFormat);
    }

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-sp2-option]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-sp2-option'), 10);
        var checked = group.querySelector('input[type="radio"]:checked');
        opts[idx] = checked ? checked.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < v.options.length; j++) {
          if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function waHref(variantId) {
      var msg = (data.waIntro || '') + ' ' + data.origin + data.productUrl + (variantId ? '?variant=' + variantId : '');
      return 'https://api.whatsapp.com/send?phone=' + encodeURIComponent(data.waPhone || '') + '&text=' + encodeURIComponent(msg);
    }

    function variantLabel(v) {
      if (data.colorIndex >= 0 && v.options[data.colorIndex]) return v.options[data.colorIndex];
      return v.title;
    }

    // Gallery: every photo of the selected colour (Globo "group images by swatch")
    var galleryEl = root.querySelector('[data-sp2-gallery]');
    var counterEl = root.querySelector('[data-sp2-counter]');
    var groups = data.gallery || {};
    var shared = data.galleryShared || [];
    var galleryKey = initial && data.groupIndex >= 0 ? initial.options[data.groupIndex] : null;
    function fileOf(src) { return String(src || '').split('?')[0].split('/').pop(); }
    function tileFigure(img) {
      var fig = document.createElement('figure');
      fig.className = 'sp2-media sp2-media--tile';
      var el = document.createElement('img');
      el.src = sized(img.s, 1100);
      el.srcset = [600, 1100, 1500].map(function (w) { return sized(img.s, w) + ' ' + w + 'w'; }).join(', ');
      el.sizes = '(min-width: 990px) 29vw, 100vw';
      if (img.w) el.width = img.w;
      if (img.h) el.height = img.h;
      el.alt = img.a || '';
      el.loading = 'lazy';
      fig.appendChild(el);
      return fig;
    }
    function cropFigure(src, second) {
      var fig = document.createElement('figure');
      fig.className = 'sp2-media sp2-media--tile sp2-crop' + (second ? ' sp2-crop--b' : '');
      var el = document.createElement('img');
      el.setAttribute('data-sp2-crop', '');
      el.src = sized(src, 1400);
      el.alt = '';
      el.width = 1400;
      el.height = 1400;
      el.loading = 'lazy';
      fig.appendChild(el);
      return fig;
    }
    function refreshCounter() {
      if (!galleryEl || !counterEl) return;
      var total = galleryEl.children.length;
      counterEl.textContent = '1 / ' + total;
      counterEl.hidden = total < 2;
    }
    function renderGallery(v) {
      if (!galleryEl || data.groupIndex < 0) return;
      var key = v.options[data.groupIndex];
      var list = (groups[key] || []).slice();
      var featured = v.featured_image && v.featured_image.src ? v.featured_image.src : null;
      if (!list.length && !featured) return;
      if (key === galleryKey && !featured) return;
      // Selected variant's own photo first
      if (featured) {
        var f = fileOf(featured);
        var at = -1;
        for (var i = 0; i < list.length; i++) { if (fileOf(list[i].s) === f) { at = i; break; } }
        if (at > 0) list.unshift(list.splice(at, 1)[0]);
        if (at < 0) list.unshift({ s: featured, a: '' });
      }
      var heroSrc = list[0].s;
      var heroImg = root.querySelector('[data-sp2-hero]');
      var same = heroImg && fileOf(heroImg.currentSrc || heroImg.src) === fileOf(heroSrc);
      if (key === galleryKey && same) return;
      galleryKey = key;
      var alt = product.title + ' — ' + variantLabel(v);
      root.querySelectorAll('[data-sp2-hero]').forEach(function (img) {
        img.srcset = srcset(heroSrc);
        img.src = sized(heroSrc, 1500);
        img.alt = alt;
      });
      root.querySelectorAll('[data-sp2-zoom-img]').forEach(function (img) { img.src = sized(heroSrc, 2400); img.alt = alt; });
      galleryEl.querySelectorAll('.sp2-media--tile').forEach(function (fig) { fig.remove(); });
      var rest = list.slice(1).concat(shared).slice(0, 8);
      if (rest.length) {
        rest.forEach(function (img) { galleryEl.appendChild(tileFigure(img)); });
      } else if (data.crops) {
        galleryEl.appendChild(cropFigure(heroSrc, false));
        galleryEl.appendChild(cropFigure(heroSrc, true));
      }
      refreshCounter();
      if (galleryEl.scrollLeft) galleryEl.scrollTo({ left: 0, behavior: 'smooth' });
    }

    // Condition, inclusions and pre-loved follow the variant (custom.condition, custom.inclusions,
    // custom.preloved on the variant, else the product values)
    var meta = data.meta || {};
    var metaVariants = meta.variants || {};
    var labels = meta.labels || {};
    function applyMeta(v) {
      var m = metaVariants[String(v.id)] || {};
      var cond = String(m.c || meta.cond || '').trim();
      var inc = String(m.i || meta.inc || '').trim();
      var word = labels[cond.toUpperCase()] || '';
      root.querySelectorAll('[data-sp2-preloved]').forEach(function (el) { el.hidden = !m.p; });
      root.querySelectorAll('[data-sp2-spec="condition"]').forEach(function (el) {
        if (cond) el.textContent = word ? cond + ' · ' + word : cond;
      });
      root.querySelectorAll('[data-sp2-spec="inclusions"]').forEach(function (el) { if (inc) el.textContent = inc; });
      root.querySelectorAll('[data-sp2-cond]').forEach(function (el) {
        var up = cond.toUpperCase();
        el.setAttribute('data-step', up === 'A' ? '1' : up === 'B' ? '2' : '3');
        var w = el.querySelector('[data-sp2-cond-word]');
        if (w && word) w.textContent = word;
      });
      if (meta.badgeAuto) {
        root.querySelectorAll('[data-sp2-badge]').forEach(function (el) {
          el.textContent = word ? word + (inc ? ' · ' + inc : '') : (meta.badge || '');
        });
      }
    }

    function update(v) {
      if (!v) {
        addButtons.forEach(function (b) { b.disabled = true; });
        return;
      }
      addButtons.forEach(function (b) { b.disabled = false; });
      if (idInput) idInput.value = v.id;
      current = v;
      if (errorEl) errorEl.hidden = true;

      var info = expInfo(v);
      var shipOn = !!info && (data.mode !== 'discuss' || !!ex.discussAtc);
      // Same price for 24h and standard: no choice to make, 24h it is
      var samePrice = !!info && info.price === v.price;
      if (samePrice) {
        shipMode = 'express';
        root.querySelectorAll('[data-sp2-ship-input][value="express"]').forEach(function (r) { r.checked = true; });
      }
      root.querySelectorAll('[data-sp2-ship-standard]').forEach(function (el) { el.hidden = data.mode === 'discuss' || samePrice; });
      var useExpress = shipOn && (shipMode === 'express' || data.mode === 'discuss');
      var shownCents = useExpress ? info.price : v.price;

      var priceStr = priceText(shownCents);
      root.querySelectorAll('[data-sp2-price]').forEach(function (el) { el.textContent = priceStr; });
      root.querySelectorAll('[data-sp2-compare]').forEach(function (el) {
        if (data.showCompare && v.compare_at_price && v.compare_at_price > shownCents) {
          el.textContent = priceText(v.compare_at_price);
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
      root.querySelectorAll('[data-sp2-quarter]').forEach(function (el) { el.textContent = priceText(Math.floor(shownCents / 4)); });

      // Delivery choice (24h / standard)
      root.querySelectorAll('[data-sp2-ship]').forEach(function (box) { box.hidden = !shipOn; });
      if (info) {
        root.querySelectorAll('[data-sp2-ship-price="express"]').forEach(function (el) { el.textContent = priceText(info.price); });
        root.querySelectorAll('[data-sp2-ship-price="standard"]').forEach(function (el) { el.textContent = priceText(v.price); });
      }
      if (expressProp) expressProp.disabled = !useExpress;
      root.querySelectorAll('[data-sp2-express-hero]').forEach(function (el) { el.hidden = !info; });
      root.querySelectorAll('[data-sp2-opt-value]').forEach(function (el) {
        var i = parseInt(el.getAttribute('data-sp2-opt-value'), 10);
        el.textContent = v.options[i] || '';
      });
      root.querySelectorAll('[data-sp2-variant-title]').forEach(function (el) { el.textContent = variantLabel(v); });

      // Size tiles: price and availability for the currently selected other options
      root.querySelectorAll('[data-sp2-option]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-sp2-option'), 10);
        if (idx === data.colorIndex) return;
        var seen = {};
        var distinct = 0;
        group.querySelectorAll('input[data-sp2-input]').forEach(function (input) {
          var label = input.nextElementSibling;
          if (!label || !label.classList.contains('sp2-size')) return;
          var opts = v.options.slice();
          opts[idx] = input.value;
          var match = null;
          for (var i = 0; i < variants.length; i++) {
            var cand = variants[i];
            var same = true;
            for (var j = 0; j < opts.length; j++) { if (cand.options[j] !== opts[j]) { same = false; break; } }
            if (same) { match = cand; break; }
          }
          label.classList.toggle('is-unavailable', !match || !match.available);
          var pill = label.querySelector('[data-sp2-24]');
          if (pill) pill.hidden = !expInfo(match);
          if (match && !seen[match.price]) { seen[match.price] = true; distinct++; }
          var priceEl = label.querySelector('[data-sp2-size-price]');
          if (priceEl) priceEl.textContent = match ? priceText(match.price) : '';
        });
        var sizesBox = group.querySelector('[data-sp2-sizes]');
        if (sizesBox) sizesBox.classList.toggle('has-prices', data.sizePrices === 'always' || (data.sizePrices !== 'never' && distinct > 1));
      });

      if (data.galleryMode === 'variant') renderGallery(v);

      var available = data.mode === 'discuss' ? shipOn : !!v.available;
      root.querySelectorAll('[data-sp2-when="available"]').forEach(function (el) { el.hidden = !available; });
      root.querySelectorAll('[data-sp2-when="request"]').forEach(function (el) { el.hidden = available; });
      root.querySelectorAll('[data-sp2-status="available"]').forEach(function (el) { el.hidden = !available || shipOn; });
      root.querySelectorAll('[data-sp2-wa]').forEach(function (a) { a.href = waHref(v.id); });

      applyMeta(v);
      try {
        root.dispatchEvent(new CustomEvent('sp2:variant', { detail: { variant: v, cents: shownCents } }));
      } catch (e) { /* old browsers */ }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    // Colours that exist with the other options selected (e.g. only canvas colours once "Canvas"
    // is picked). If the selected colour does not exist there, pick the first one that does.
    function syncColours() {
      if (data.colorIndex < 0 || !variants.length || variants[0].options.length < 2) return;
      var group = root.querySelector('[data-sp2-option="' + data.colorIndex + '"]');
      if (!group) return;
      var opts = selectedOptions();
      var firstOk = null, firstAvailable = null, keepChecked = false;
      group.querySelectorAll('input[data-sp2-input]').forEach(function (input) {
        var want = opts.slice();
        want[data.colorIndex] = input.value;
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var cand = variants[i], same = true;
          for (var j = 0; j < want.length; j++) { if (want[j] != null && cand.options[j] !== want[j]) { same = false; break; } }
          if (same) { match = cand; break; }
        }
        input.disabled = !match;
        var label = input.nextElementSibling;
        if (label) label.hidden = !match;
        if (match) {
          if (!firstOk) firstOk = input;
          if (!firstAvailable && match.available) firstAvailable = input;
          if (input.checked) keepChecked = true;
        }
      });
      if (!keepChecked && (firstAvailable || firstOk)) (firstAvailable || firstOk).checked = true;
      var shown = group.querySelectorAll('input[data-sp2-input]:not(:disabled)').length;
      root.querySelectorAll('[data-sp2-colour-count]').forEach(function (el) {
        el.textContent = shown + ' colours';
        el.hidden = shown < 2;
      });
    }
    syncColours();

    root.addEventListener('change', function (e) {
      if (!e.target) return;
      if (e.target.matches('[data-sp2-input]')) {
        if (e.target.closest('[data-sp2-option]') !== root.querySelector('[data-sp2-option="' + data.colorIndex + '"]')) syncColours();
        update(findVariant(selectedOptions()));
      }
      if (e.target.matches('[data-sp2-ship-input]')) {
        shipMode = e.target.value;
        if (current) update(current);
      }
    });
    if (shipMode !== 'express' && initial) update(initial);

    // Add to cart: added in the background and shown in the cart drawer (like the rest of the site).
    // 24h stock is limited: the bag is checked first for a 24h item.
    var form = root.querySelector('[data-sp2-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (form.__sp2native) { form.__sp2native = false; return; }
        var miniCart = document.querySelector('mini-cart');
        var drawerOn = !!(window.shopSettings && window.shopSettings.cartDrawer && miniCart &&
          typeof miniCart.renderContents === 'function' && typeof miniCart.getSectionsToRender === 'function' &&
          window.routes && window.routes.cart_add_url && !document.body.classList.contains('template-cart'));
        var info = (expressProp && !expressProp.disabled && current) ? expInfo(current) : null;
        if (!drawerOn && !info) return;
        e.preventDefault();
        var btns = document.querySelectorAll('[data-sp2-add]');
        if (form.__sp2busy) return;
        form.__sp2busy = true;
        btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-disabled', 'true'); });
        if (errorEl) errorEl.hidden = true;
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var check = info
          ? fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var vid = String(current.id);
                var inBag = 0;
                (cart.items || []).forEach(function (it) {
                  if (String(it.variant_id) === vid && it.properties && it.properties['Express Shipping']) inBag += it.quantity;
                });
                if (inBag + 1 > info.qty) {
                  if (errorEl) {
                    errorEl.textContent = String(ex.limitMsg || '').replace('{qty}', info.qty);
                    errorEl.hidden = false;
                  }
                  return false;
                }
                return true;
              })
          : Promise.resolve(true);
        function done() {
          form.__sp2busy = false;
          btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-disabled'); });
        }
        function native() { done(); form.__sp2native = true; if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
        check.then(function (ok) {
          if (!ok) { done(); return; }
          if (!drawerOn) { native(); return; }
          var fd = new FormData(form);
          fd.append('sections', miniCart.getSectionsToRender().map(function (x) { return x.id; }));
          fd.append('sections_url', window.location.pathname);
          return fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: fd
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              done();
              if (res && res.status) {
                if (errorEl) { errorEl.textContent = res.description || res.message || 'This piece could not be added.'; errorEl.hidden = false; }
                return;
              }
              miniCart.renderContents(res);
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res } }));
            });
        }).catch(function () { native(); });
      });
    }

    // Mobile rails (colours, sizes): bring the selected value into view
    function revealSelected() {
      root.querySelectorAll('[data-sp2-rail], [data-sp2-sizes]').forEach(function (rail) {
        if (rail.scrollWidth <= rail.clientWidth + 2) return;
        var tile = rail.querySelector('.sp2-radio:checked + .sp2-tile, .sp2-radio:checked + .sp2-size, .sp2-tile.is-current');
        if (!tile) return;
        var r = rail.getBoundingClientRect();
        var t = tile.getBoundingClientRect();
        if (t.right > r.right - 12 || t.left < r.left) rail.scrollLeft += t.left - r.left - 16;
      });
    }
    revealSelected();
    window.addEventListener('load', revealSelected);

    // Description "read more"
    root.querySelectorAll('[data-sp2-desc]').forEach(function (desc) {
      var btn = desc.nextElementSibling;
      if (!btn || !btn.hasAttribute('data-sp2-more')) return;
      function check() {
        var details = desc.closest('details');
        if (details && !details.open) return;
        btn.hidden = desc.classList.contains('is-open') || desc.scrollHeight <= desc.clientHeight + 4;
      }
      btn.addEventListener('click', function () {
        desc.classList.add('is-open');
        btn.hidden = true;
      });
      var details = desc.closest('details');
      if (details) details.addEventListener('toggle', check);
      window.addEventListener('load', check);
      check();
    });

    // Zoom
    var dialog = root.querySelector('[data-sp2-zoom]');
    if (dialog && typeof dialog.showModal === 'function') {
      root.querySelectorAll('[data-sp2-zoom-open]').forEach(function (btn) {
        btn.addEventListener('click', function () { dialog.showModal(); });
      });
      dialog.querySelectorAll('[data-sp2-zoom-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { dialog.close(); });
      });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }

    // Information windows (condition, inclusions, delivery, certificate, size guide)
    function openDialog(dlg) {
      if (!dlg) return;
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('sp2-lock');
    }
    function closeDialog(dlg) {
      if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
      document.documentElement.classList.remove('sp2-lock');
    }
    root.querySelectorAll('[data-sp2-dialog-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openDialog(document.getElementById(btn.getAttribute('data-sp2-dialog-open'))); });
    });
    root.querySelectorAll('[data-sp2-dialog]').forEach(function (dlg) {
      dlg.querySelectorAll('[data-sp2-dialog-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { closeDialog(dlg); });
      });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDialog(dlg); });
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('sp2-lock'); });
    });

    // Size guide: wide tables (one column per size) read better turned on their side
    root.querySelectorAll('.sp2-size-table table').forEach(function (table) {
      var rows = Array.prototype.map.call(table.querySelectorAll('tr'), function (tr) {
        return Array.prototype.map.call(tr.children, function (c) { return c.textContent.trim(); });
      }).filter(function (r) { return r.length; });
      if (!rows.length) return;
      var cols = rows[0].length;
      if (cols <= rows.length * 2) return;
      var html = '<thead><tr>' + rows.map(function (r) { return '<th>' + (r[0] || '') + '</th>'; }).join('') + '</tr></thead><tbody>';
      for (var c = 1; c < cols; c++) {
        html += '<tr>' + rows.map(function (r) { return '<td>' + (r[c] || '') + '</td>'; }).join('') + '</tr>';
      }
      table.innerHTML = html + '</tbody>';
      table.classList.add('is-turned');
    });

    // Service that opens an accordion (instalments)
    root.querySelectorAll('[data-sp2-acc-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = document.getElementById(btn.getAttribute('data-sp2-acc-open'));
        if (!d) return;
        if (d.tagName === 'DETAILS') d.open = true;
        d.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    // Mobile gallery counter
    var gallery = root.querySelector('[data-sp2-gallery]');
    var counter = root.querySelector('[data-sp2-counter]');
    if (gallery && counter) {
      var ticking = false;
      gallery.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var total = gallery.children.length;
          var w = gallery.clientWidth || 1;
          var idx = Math.min(total, Math.round(gallery.scrollLeft / w) + 1);
          counter.textContent = idx + ' / ' + total;
          ticking = false;
        });
      }, { passive: true });
    }

    // Hide a leading "Description" heading inside the description (the accordion already says it)
    root.querySelectorAll('[data-sp2-desc]').forEach(function (desc) {
      var first = desc.firstElementChild;
      if (first && /^H[1-6]$/.test(first.tagName) && first.textContent.trim().toLowerCase() === 'description') first.hidden = true;
    });

    // Desktop: keep the shorter gallery in view while the longer panel scrolls
    var galleryWrap = root.querySelector('.sp2-gallery-wrap');
    var panel = root.querySelector('.sp2-panel');
    function headerHeight() {
      var h = document.querySelector('#shopify-section-headerV2') || document.querySelector('.shopify-section-group-header-group');
      if (!h) return 0;
      var pos = window.getComputedStyle(h).position;
      if (pos !== 'sticky' && pos !== 'fixed') return 0;
      return Math.max(0, Math.round(h.getBoundingClientRect().height));
    }
    function stickGallery() {
      var hh = headerHeight();
      root.style.setProperty('--sp2-header-h', hh + 'px');
      root.style.setProperty('--sp2-sticky-top', (hh + 32) + 'px');
      if (!galleryWrap || !panel) return;
      var gh = galleryWrap.offsetHeight;
      if (window.innerWidth >= 990 && gh + 40 < panel.offsetHeight) {
        galleryWrap.style.position = 'sticky';
        galleryWrap.style.alignSelf = 'start';
        galleryWrap.style.top = Math.min(hh, window.innerHeight - gh - 24) + 'px';
      } else {
        galleryWrap.style.position = '';
        galleryWrap.style.alignSelf = '';
        galleryWrap.style.top = '';
      }
    }
    stickGallery();
    window.addEventListener('load', stickGallery);
    window.addEventListener('resize', stickGallery);
    if ('ResizeObserver' in window && galleryWrap && panel) {
      var ro = new ResizeObserver(stickGallery);
      ro.observe(galleryWrap);
      ro.observe(panel);
    }

    // Mobile sticky bar
    var bar = root.querySelector('[data-sp2-bar]');
    var anchor = root.querySelector('[data-sp2-buy]');
    if (bar && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', past);
          bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        });
      });
      io.observe(anchor);
    }
  }

  // Live Reviews.io rating (public stats endpoint)
  var statsCache = {};
  function getStats(store) {
    if (statsCache[store]) return statsCache[store];
    var key = 'sp2-reviews-' + store;
    try {
      var cached = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      if (cached && cached.total) { statsCache[store] = Promise.resolve(cached); return statsCache[store]; }
    } catch (e) { /* storage unavailable */ }
    statsCache[store] = fetch('https://api.reviews.io/merchant/reviews?store=' + encodeURIComponent(store) + '&per_page=1')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.stats) return null;
        var s = { avg: parseFloat(d.stats.average_rating), total: parseInt(d.stats.total_reviews, 10), word: d.word || '' };
        try { window.sessionStorage.setItem(key, JSON.stringify(s)); } catch (e) { /* ignore */ }
        return s;
      })
      .catch(function () { return null; });
    return statsCache[store];
  }

  function fillRatings() {
    document.querySelectorAll('[data-sp2-rating]').forEach(function (el) {
      if (el.__sp2r) return;
      el.__sp2r = true;
      var store = el.getAttribute('data-store');
      if (!store) return;
      getStats(store).then(function (s) {
        if (!s || !s.total || isNaN(s.avg)) return;
        var targets = el.hasAttribute('data-template') ? [el] : el.querySelectorAll('[data-template]');
        Array.prototype.forEach.call(targets, function (t) {
          t.textContent = t.getAttribute('data-template')
            .replace('{avg}', s.avg.toFixed(2))
            .replace('{total}', s.total.toLocaleString('en-US'))
            .replace('{word}', s.word);
        });
        el.hidden = false;
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-sp2-root]').forEach(init);
    document.querySelectorAll('[data-sp2-related]').forEach(loadRelated);
    fillRatings();
  }

  function loadRelated(el) {
    if (el.__sp2) return;
    el.__sp2 = true;
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-sp2-related]');
        var grid = fresh ? fresh.querySelector('.sp2-rel-grid') : null;
        if (grid && grid.children.length) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = false;
        } else {
          var section = el.closest('.sp2');
          if (section) section.hidden = true;
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
